'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeDonation = exports.fetchDonationFeed = undefined;

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

var _jsonDate = require('../../../utils/jsonDate');

var _jsonDate2 = _interopRequireDefault(_jsonDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchDonationFeed = exports.fetchDonationFeed = function fetchDonationFeed(_ref) {
  var campaign = _ref.campaign,
      charity = _ref.charity,
      event = _ref.event,
      page = _ref.page,
      donationRef = _ref.donationRef;

  if (page) {
    return fetchDonationFeedForPage(page);
  }

  if (donationRef) {
    return fetchDonationFeedByRef(donationRef);
  }

  if (charity || campaign || event) {
    return fetchDonations({ charity: charity, campaign: campaign, event: event });
  }

  return Promise.reject('You must pass a charity UID, page shortName, campaign GUID or donationRef for this method');
};

var mapValue = function mapValue(v) {
  return Array.isArray(v) ? v.map(_params.getUID) : (0, _params.getUID)(v);
};

var fetchDonations = function fetchDonations(_ref2) {
  var event = _ref2.event,
      charity = _ref2.charity,
      campaign = _ref2.campaign;
  return _client.servicesAPI.get('/v1/justgiving/donations', {
    params: {
      eventId: mapValue(event),
      charityId: mapValue(charity),
      campaignGuid: mapValue(campaign)
    },
    paramsSerializer: function paramsSerializer(params) {
      return _queryString2.default.stringify(params, { arrayFormat: 'comma' });
    }
  }).then(function (response) {
    return response.data;
  }).then(function (data) {
    return data.results;
  });
};

var fetchDonationFeedForPage = function fetchDonationFeedForPage(page) {
  return (0, _client.get)('v1/fundraising/pages/' + (0, _params.getShortName)(page) + '/donations?pageSize=150').then(function (data) {
    return data.donations;
  });
};

var fetchDonationFeedByRef = function fetchDonationFeedByRef(ref) {
  return (0, _client.get)('v1/donation/ref/' + ref).then(function (data) {
    return data.donations;
  });
};

var deserializeDonation = exports.deserializeDonation = function deserializeDonation(donation) {
  var isFromDonationsAPI = !!donation.donationId;

  return {
    amount: parseFloat(donation.donorLocalAmount || donation.amount || donation.donationAmount || 0),
    anonymous: isFromDonationsAPI ? !donation.donor : !donation.donorDisplayName || donation.donorDisplayName.toLowerCase().trim() === 'anonymous',
    charity: donation.charityId,
    createdAt: donation.donationDate ? (0, _jsonDate2.default)(donation.donationDate) : (0, _jsonDate2.default)(donation.date),
    currency: donation.donorLocalCurrencyCode || donation.currencyCode,
    donationRef: donation.thirdPartyReference,
    message: donation.message || donation.donorMessage,
    name: isFromDonationsAPI ? donation.donor && donation.donor.name : donation.donorDisplayName,
    page: donation.pageShortName
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/feeds/justgiving/index.js
// module id = 1323
// module chunks = 0